/**
 * Talk to app's backend
 */
const BACKEND_URL = "https://newgroups.vk.deserter-app.ru";

/**
 * Once we get own top group id via execute.getTip()
 * save that to the backend just for stats.
 * Backend does not quite trust user-provided data anyway.
 * @param {Number} topGroupId
 * @param {Object} startParams VK Mini app start parameters
 */
async function saveTopGroupId(topGroupId, startParams) {
  // save to server
  const data = { n: topGroupId, ...startParams };
  const url = new URL("/mini/update", BACKEND_URL);

  await fetch(
    url,
    {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      redirect: "follow",
      referrerPolicy: "no-referrer",
      body: JSON.stringify(data),
    }
  )
    .then((d) => console.log({ status: d.status, url: d.url, msg: "Saved" }))
    .catch((error) => {
      console.error(error);
    })
    ;
}

/**
 * @typedef {Object} BackendTop
 * @property {Number} BackendTop.group_id tip group id
 * @property {Number} BackendTop.timestamp when this tip was fetched
 * @property {Boolean} [BackendTop.cached] true if backend returned cached version
 */

/**
 * Get tip group id saved on backend.
 * Backend tip is refreshed by a cron job every 10 minutes, or so.
 * @param {Object} startParams VK Mini app start parameters
 * @returns {Promise<BackendTop>}
 */
async function getServerSavedTop(startParams) {
  const url = new URL("/mini/top", BACKEND_URL);
  for (const [key, value] of Object.entries(startParams)) {
    url.searchParams.append(key, value);
  }

  const backendTop = await fetch(url, {
    method: "GET",
    mode: "cors",
    cache: "no-cache",
    credentials: "same-origin",
    headers: {
      // "Content-Type": "application/json",
    },
    redirect: "follow",
    referrerPolicy: "no-referrer",
  })
  .then((response) => response.json())
  .catch((error) => {
    console.error(error);
  });

  return backendTop;
}


/**
 * Get array of group ids and timestamps
 * Backend tip is refreshed by a cron job every 10 minutes
 * @param {Object} startParams VK Mini app start parameters
 * @returns {Promise<BackendTimes>}
 */
async function getTimes(startParams) {
  const url = new URL("/mini/times", BACKEND_URL);
  for (const [key, value] of Object.entries(startParams)) {
    url.searchParams.append(key, value);
  }

  const backendTimes = await fetch(url, {
    method: "GET",
    mode: "cors",
    cache: "no-cache",
    credentials: "same-origin",
    headers: {
      // "Content-Type": "application/json",
    },
    redirect: "follow",
    referrerPolicy: "no-referrer",
  })
  .then((response) => response.json())
  .catch((error) => {
    console.error(error);
  });

  return backendTimes;
}

export {
  getServerSavedTop,
  getTimes,
  saveTopGroupId,
}
